export interface CardholderDetails {
  phone?: string | null;
  birthdate?: string | number | Date | null;
  address?: {
    address1?: string | null;
    city?: string | null;
    state?: string | null;
  } | null;
}

/** Mirrors createCardholder on the server, which refuses a person missing any of these. */
export const missingCardholderDetails = (
  person?: CardholderDetails | null,
): boolean =>
  !person?.phone ||
  !person?.birthdate ||
  !person?.address?.address1 ||
  !person?.address?.city ||
  !person?.address?.state;
